import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AuthenticationService } from './core/auth/authentication.service';
import { CurrentUser } from './core/auth/models/current-user';
import { SEOService } from './features/home/seo/seo.service';
import { ChatService } from './store/chat/chat.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private _authService: AuthenticationService,
    private _chatService: ChatService,
    private _seoService: SEOService,
    @Inject(PLATFORM_ID) private _platformId: Object
  ) {}

  get isAuthenticated() {
    return this._authService.isAuthenticated();
  }

  ngOnInit(): void {
    this._seoService.updateTitle();
    if (isPlatformBrowser(this._platformId)) {
      this._authService.currentUserChanged$.subscribe((currentUser: CurrentUser) => {
        if (currentUser) {
          this._chatService.initializeWebSocketConnection();
        } else {
          this._chatService.disconnectWebSocketConnection();
        }
      });
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
          this._chatService.initializeWebSocketConnection();
        }
      });
    }
  }
}
